import { FOOTER, MENU_API, NAVBAR_ACTIVE, SET_LANGUAGE } from "./globalTypes";

const initialState = {
    navbarActive: '/home',
    menuApi: [],
    footer: {
        sosmed: null,
        general: null
    },
    language: typeof window !== "undefined" ? localStorage.getItem("language") || "en" : "en"
}

const globalReducers = (state = initialState, action) => {
    let key, value;
    switch (action.type) {
        case NAVBAR_ACTIVE:
            return {
                ...state,
                navbarActive: action?.payload?.value,
            };
        case MENU_API:
            return {
                ...state,
                menuApi: action?.payload?.value,
            };
        case SET_LANGUAGE:
            return {
                ...state,
                language: action?.payload?.value,
            };
        case FOOTER:
            ({ key, value } = action.payload);
            return {
                ...state,
                footer: {
                    ...state.footer,
                    [key]: value
                }
            };
        default:
            return state;
    }
}

export default globalReducers;